import { Duration, Effect, Option } from 'effect';

import { checkTokenStatus, isLoggedIn } from '../../auth/jwt';
import { DEFAULT_TIMEZONE } from '../../config/clock';
import { AuthToken } from '../../service/auth/AuthToken';

export const getAuthTokenOption = Effect.gen(function* () {
  const auth = yield* AuthToken;

  return yield* auth.getToken.pipe(
    Effect.catchTags({
      '@app/AuthToken/AuthTokenGetError': () => Effect.succeed(Option.none<string>()),
    })
  );
});

/**
 * The held token while it still authenticates a request, as the request
 * pipeline decides it. An expired token answers `None`, so the request goes
 * out anonymous. This does not clear the expired token.
 */
export const getValidAuthTokenOption = Effect.gen(function* () {
  const token = yield* getAuthTokenOption;
  const status = yield* checkTokenStatus(token, Duration.minutes(5), DEFAULT_TIMEZONE);

  return isLoggedIn(status) ? token : Option.none<string>();
});
